<template>
  <div class="sign-sale">
    <div class="sign-sale-header">
        <h1 style="font-weight:500;">רוסמן מרקט</h1>
    </div>
    <div class="sign-sale-input-texts">
        <div class="he">
            <el-input :input-style="input_style" style="width:50%;" v-if="!is_sales_print" v-model="clone_sign.RemarkForPrint" maxlength="35" placeholder="שם המוצר בעברית" />
            <h1 :style="getDynamicStyles" v-if="is_sales_print">{{formattedName}}</h1>
        </div>
        <i v-if="is_catalog_signs"  @click="handle_show_items_list" class="material-icons float-icon add-icon">add</i>
    </div>
    <div v-if="!is_catalog_signs" class="sign-sale-contents">
        <div class="col-2 col">
            <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.amount" placeholder="הזן מספר" />
            <h1 style="font-weight:600;" v-if="is_sales_print && Number(sign?.amount) > 0.01 && !sign?.Department?.includes('שקיל') && !sign?.Department?.includes('משקל')"> {{clone_sign.amount}} יח'</h1>
            <h1 style="font-weight:600;" v-else-if="is_sales_print && (Number(sign?.amount) < 1 || sign?.Department?.includes('שקיל') || sign?.Department?.includes('משקל'))">{{clone_sign.amount}} ק"ג</h1>
        </div>
        <div class="col-1 col">
            <h1 style="font-weight:600;">ב-</h1>
        </div>
        <div class="col-2 col">
            <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.sum_price" placeholder="הזן מספר" />
            <h1 style="font-weight:600;" v-if="is_sales_print">{{clone_sign.sum_price}}<small style="font-weight:600;"> &#8362;</small></h1>
        </div>
    </div>
    <div v-else class="sign-sale-contents catalog">
        <div v-if="!is_sales_print" class="col-2 col">
            <el-input :input-style="input_style" type="number" v-model="clone_sign.price" placeholder="מחיר" />
        </div>
        <div v-if="!is_sales_print" class="col-1 col">
            <h1 style="font-weight:600;">ל-</h1>
        </div>
        <div v-if="!is_sales_print" class="col-2 col">
            <el-input style="width:30%; margin:0 3px" :input-style="input_style"  v-model="clone_sign.qnt" placeholder="כמות" />
            <el-input style="width:30%;" :input-style="input_style"  v-model="clone_sign.unit" placeholder="מידה" />
        </div>
        <template v-if="is_sales_print">
            <h1 style="font-weight:700; font-size:38px;">&#8362;{{clone_sign.price}}</h1>
            <h2 style="font-weight:500; font-size:16px;">ל - {{clone_sign.unit}}</h2>
        </template>
    </div>
    <div class="sign-sale-footer">
        <div class="footer-right">
            <span style="font-weight:600;">ברקוד: </span>
            <span style="font-weight:600;" v-if="clone_sign?.barcode">{{clone_sign?.barcode.slice(-4)}}</span>
        </div>
        <div class="footer-left" v-if="clone_sign.country">
            <span style="font-weight: 500; white-space: nowrap;">מיוצר ב{{clone_sign.country}}</span>
        </div>
    </div>
    <div v-if="show_items_list" class="choos-item slide-in-top">
        <ItemsList @back="show_items_list=false; clone_sign={};" @item_choosen="handle_item_choosen" />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import {is_sales_print} from '../../Scripts/scripts'
import {is_catalog_signs} from '../Deals/Scripts/store'
import { computed, defineAsyncComponent, onBeforeUnmount } from 'vue'
import {translate_hebrew_to_russian} from '../../components/Deals/Scripts/script'
import {printer_amount} from '../../components/Deals/Scripts/store'
import {slide_pop_error} from '../../../../../Methods/Msgs'



export default {
    props:['sign'],
    components:{
        ItemsList:defineAsyncComponent(()=>import('../../ItemsList.vue')),
    },
    setup(props){

        const show_error = ref(false)
        const translate_action = ref(false)

        const dotsCount = ref(0);

        const loadingDots = computed(() => {
            const dots = ['.', '..', '...'];
            return dots[dotsCount.value % dots.length];
        });

        const interval = setInterval(() => {
            dotsCount.value++;
        }, 1000);

        const handle_translate_to_ru = async(hebrew) => {
            try{
                if(!hebrew){
                    throw new Error('עליך להזין שם המוצר בעברית תחילה!')
                }else{
                    clone_sign.value.ru_name = null
                    translate_action.value = true
                    clone_sign.value.ru_name = await translate_hebrew_to_russian(hebrew)
                }
            }catch(err){
                clone_sign.value.ru_name = null
                translate_action.value = false
                slide_pop_error(err.message)
            }
        }

        const handle_show_items_list = () => {
            show_items_list.value=true
            clone_sign.value.ru_name = null
            clone_sign.value.ru_name = null
            translate_action.value = false
        }

        const ru_loader = ref(false)
        const show_items_list = ref(false)

        const clone_sign = ref({})

        const input_style = ref({
            'font-size':'16px',
            'color':'black',
            'margin-top':'5px',
            'text-align': 'center',
            'border': '2px solid black',
            'border-left':'0',
            'border-right':'0',
            'border-top':'0',
        })

        const handle_item_choosen = (item) => {
            show_items_list.value = false
            const isWeight = item.amount == '0.01'
                || item.Department?.includes('שקיל')
                || item.Department?.includes('משקל');
            clone_sign.value = {
                RemarkForPrint:item.Name,
                barcode:item.barcode,
                price:isWeight?(Number(item?.price)/10).toFixed(2):item?.price,
                amount:item.amount,
                unit:isWeight?'100 גרם':'יח\'',
                qnt:"1",
                country:item.country,
                Department:item.Department
            }
        }

        const handle_translate_manuel = () => {
            clone_sign.value.ru_name=''
            show_error.value = false
            printer_amount.value.push(1)
        }

        onBeforeUnmount(()=>{
            if(interval){
                clearInterval(interval);
            }
        })

        const getDynamicStyles = computed(() => {
            const text = clone_sign.value?.RemarkForPrint || '';
            const words = text.trim().split(/\s+/);
            const wordCount = words.length;
            let fontSize, lineHeight;
            if (wordCount <= 3) {
                fontSize = '26px';
                lineHeight = '1.2';
            } else {
                fontSize = '22px';
                lineHeight = '1.15';
            }
            return {
                fontWeight: 600,
                fontSize,
                lineHeight,
                margin: 0,
                padding: '2px',
                wordBreak: 'keep-all',
                whiteSpace: 'pre-line',
                overflow: 'hidden',
                maxHeight: '100%',
                textAlign: 'center',
                width: '100%',
            };
        });

        const formattedName = computed(() => {
            const text = clone_sign.value?.RemarkForPrint || '';
            const words = text.trim().split(/\s+/);
            if (words.length <= 3) {
                return text;
            }
            const firstLine = words.slice(0, 3).join(' ');
            const secondLine = words.slice(3).join(' ');
            return firstLine + '\n' + secondLine;
        });

        return{
            is_sales_print,
            input_style,
            clone_sign,
            is_catalog_signs,
            show_items_list,
            handle_item_choosen,
            ru_loader,
            loadingDots,
            translate_action,
            handle_translate_to_ru,
            handle_show_items_list,
            handle_translate_manuel,
            show_error,
            getDynamicStyles,
            formattedName
        }
    }
}
</script>

<style scoped>
    h1, h2, h3 { margin: 0; font-size: inherit; }
    .sign-sale{
        position: relative;
        width: 100%;
        height: 100%;
    }
    .sign-sale-header{
        position: relative;
        width: 100%;
        height: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
    }
    .logo{
        position: absolute;
        width: 60px;
        height: 100%;
        top: 0;
        left: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo img{
        max-width: 100%;
        max-height: 100%;
    }
    .sign-sale-input-texts{
        position: relative;
        width: 100%;
        height: 30%;
    }
    .add-icon,.clean-icon{
        color: var(--success);
        cursor: pointer;
        font-size: 35px;
        user-select: none;
    }
    .float-icon{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 3px;
    }
    .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
        position: relative;
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        text-align: center;
    }
    .sign-sale-input-texts .ru{
        font-size: 9px;
    }
    .add_translation{
        position: absolute;
        top: 50%;
        left: 30px;
        transform: translateY(-50%);
        width: 80px;
    }
    .float-icon,.save-icon,.add-deal-icon{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 30px;
    }
    .save-icon,.add-deal-icon{
        right: unset;
        left: 30px;
        color: var(--blue) !important;
    }
    .add-icon,.clean-icon,.save-icon,.add-deal-icon{
        color: var(--success);
        cursor: pointer;
        font-size: 28px;
        user-select: none;
    }
    .add-deal-icon::before{
        content: 'בחירת מבצע';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        left: -50%;
        font-family: 'Rubik', sans-serif;
    }
    .save-icon::before{
        content: 'שמירת מבצע';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        left: -50%;
        font-family: 'Rubik', sans-serif;
    }
    .clean-icon{
        color: var(--danger);
    }
    .clean-icon::before{
        content: 'נקה';
        font-size: 12px;
        position: absolute;
        bottom: 115%;
        right: 50%;
        transform: translateX(50%);
        font-family: 'Rubik', sans-serif;
    }
    .add-icon::before{
        content: 'בחירת פריט';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        right: 50%;
        transform: translateX(50%);
        font-family: 'Rubik', sans-serif;
    }
    .sign-sale-contents{
        width: 100%;
        height: 40%;
        display: flex;
        font-size: 20px;
    }
    .sign-sale-contents.catalog{
        justify-content: center;
        align-items: center;
    }
    .col{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .col-1{
        width: 10%;
        height: 100%;
    }
    .col-2{
        width: 45%;
        height: 100%;
    }
    .col.barcodes{
        justify-content:unset;
        padding: 0 3px;
        width: 40%;
        font-size: 8px;
    }
    .col.small{
        font-size: unset;
        text-align: center;
        width: 30%;
        font-size: 14px;
    }
    .col.price{
        width: 30%;
        font-size: 14px;
        flex-direction: column;
        justify-content: center;
    }
    .col.price > small{
        font-weight: 500;
        font-size: 10px;
    }
    [data-slice]{
        white-space: nowrap;
        overflow: hidden;
        margin-right: 3px;
    }
    [data-fixed]{
        display: flex;
        align-items: center;
    }
    .sign-sale-footer{
        width: 100%;
        height: 10%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        font-size: 12px;
    }
    .sign-sale-footer.item-error{
        justify-content: center;
        align-items: center;
        color: red;
    }
    .choos-item,.choos-deal{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--main);
        z-index: 1000;
    }

    .slide-in-top {
	-webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    @-webkit-keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
                transform: translateY(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
                transform: translateY(0);
        opacity: 1;
    }
    }
    @keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
                transform: translateY(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
                transform: translateY(0);
        opacity: 1;
    }
    }
</style>
